import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "../../../Components/Button/Button";
import "./ModalDescargaBaseDatos.css";

const DownloadIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M8 1v9M8 10l-3-3M8 10l3-3M2 12v1a1 1 0 001 1h10a1 1 0 001-1v-1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const DatabaseIcon = () => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <ellipse cx="15" cy="6.5" rx="10.5" ry="4" stroke="currentColor" strokeWidth="2.5" />
        <path d="M4.5 6.5V22.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M25.5 6.5V22.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <path
            d="M4.5 14.5C4.5 16.7091 9.20101 18.5 15 18.5C20.799 18.5 25.5 16.7091 25.5 14.5"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
        />
        <path
            d="M4.5 22.5C4.5 24.7091 9.20101 26.5 15 26.5C20.799 26.5 25.5 24.7091 25.5 22.5"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
        />
    </svg>
);

const ModalDescargaBaseDatos = ({
    show,
    onHide,
    anio,
    trimestre,
    archivos,
    onDownload,
}) => {
    const subtitulo = anio && trimestre ? `${anio} - ${trimestre}` : "";

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdropClassName="backdrop-dark"
            dialogClassName="modal-descarga-bd-shell"
            contentClassName="modal-descarga-bd-content"
        >
            <Modal.Body className="modal-descarga-bd-body">
                <div className="modal-descarga-bd">
                    <div className="modal-descarga-bd__header">
                        <div className="modal-descarga-bd__heading">
                            <h5 className="modal-descarga-bd__title">Descarga de respaldos</h5>
                            <p className="modal-descarga-bd__subtitle">{subtitulo}</p>
                        </div>
                        <button
                            type="button"
                            className="modal-descarga-bd__close"
                            onClick={onHide}
                            aria-label="Cerrar modal"
                        >
                            <i className="ico-close"></i>
                        </button>
                    </div>

                    <div className="modal-descarga-bd__list">
                        {archivos.map((archivo) => (
                            <div key={archivo.nombre} className="modal-descarga-bd__item">
                                <div className="modal-descarga-bd__database">
                                    <figure className="box-icon modal-descarga-bd__icon">
                                        <DatabaseIcon />
                                    </figure>
                                    <span className="modal-descarga-bd__name">{archivo.nombre}</span>
                                </div>

                                <button
                                    type="button"
                                    className="backup-bd-btn-descargar modal-descarga-bd__download"
                                    onClick={() => onDownload?.(archivo)}
                                    aria-label={`Descargar ${archivo.nombre}`}
                                    title={`Descargar ${archivo.nombre}`}
                                >
                                    <DownloadIcon />
                                </button>
                            </div>
                        ))}
                    </div>

                    <div className="modal-descarga-bd__footer">
                        <Button type="button" design="btn-primary modal-descarga-bd__primary" onClick={onHide}>
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalDescargaBaseDatos;
